export function toggleFocus (dialogClassName, parent, state) {
  Array.from(parent.children).forEach(child => {
    if (!child.classList.contains(dialogClassName)) {
      setState(child, state)
      Array.from(child.querySelectorAll('*')).forEach(subchild => {
        setState(subchild, state)
      })
    }
  })
}

function setState (child, state) {
  const tabIndex = child.getAttribute('tabindex')
  const ariaHidden = child.getAttribute('aria-hidden')

  if (state) {
    child.setAttribute('data-tabindex', tabIndex !== null ? tabIndex : 'none')
    child.setAttribute('data-aria-hidden', ariaHidden !== null ? ariaHidden : 'none')
    child.setAttribute('aria-hidden', state)
    child.setAttribute('tabindex', -1)
    child.setAttribute('data-inert', child.classList.contains('inert') ? 'true' : 'false')
    child.classList.add('inert')
  } else {
    if (child.getAttribute('data-tabindex') !== 'none' && child.getAttribute('data-tabindex') !== null) {
      child.setAttribute('tabindex', child.getAttribute('data-tabindex'))
    } else {
      child.removeAttribute('tabindex')
    }

    if (child.getAttribute('data-aria-hidden') !== 'none' && child.getAttribute('data-aria-hidden') !== null) {
      child.setAttribute('aria-hidden', child.getAttribute('data-aria-hidden'))
    } else {
      child.removeAttribute('aria-hidden')
    }

    if (child.getAttribute('data-inert') === 'false') {
      child.classList.remove('inert')
    }

    child.removeAttribute('data-aria-hidden')
    child.removeAttribute('data-tabindex')
    child.removeAttribute('data-inert')
  }
}
